import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowRotateRightFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowRotateRightFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13.27 11.5H17l3.68-5-3.68-5h-3.73L15.85 5H9.82c-3.58 0-6.5 2.92-6.5 6.5v7h3v-7c0-1.93 1.57-3.5 3.5-3.5h6.03l-2.58 3.5Z" />
          <path d="M15.82 13.5h-3a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowRotateRightFilled;